<template>
  <Header :title="$t('jobHistory.title')" />
  <div v-if="readPermission" class="jobHistoryContainer">
    <div v-if="isSideBarOpen" class="jobHistoryFilter">
      <div class="jobHistoryFilterContainer">
        <div class="jobHistoryHeaderFilter">
          <div style="display: flex; flex-direction: row; justify-content: space-around; width: 100%">
            <div class="jobHeader" @click="toggleDropdown">
              <img :src="arrowDownIcon" alt="Arrow Icon" class="arrowDownIcon" :class="{ rotated: !isOpen }" />
              <img :src="vectorIcon" class="jobHistoryIcon" alt="Job History" />
              <span class="jobsTitle">{{ $t('jobHistory.jobs') }}</span>
            </div>

            <div @click="toggleSideBaDropdown">
              <img :class="{ rotated: !isSideBarOpen }" :src="hideSidebarIcon" alt="" />
            </div>
          </div>

          <div class="jobItems" v-if="isOpen">
            <div v-for="item in jobItems" :key="item" class="jobItem" :class="{ jobItemActive: selectedItem === item }" @click="selectJobItem(item)">
              <div v-if="selectedItem === item" class="vrCustom"></div>
              <span class="jobItemTitle">{{ $t(`jobStatus.${item.toLowerCase()}`) }}</span>
              <span class="jobCount" :class="getCountClass(item)" :title="getJobCount(item, true)">
                {{ getJobCount(item, 'jobs') }}
              </span>
            </div>
          </div>
        </div>
        <div class="jobHistoryHeaderFilter">
          <div class="jobHeader" @click="toggleDropdownManual">
            <img :src="arrowDownIcon" alt="Arrow Icon" class="arrowDownIcon" :class="{ rotated: !isOpenManual }" />
            <img :src="checkDoneIcon" class="jobHistoryIcon" alt="Job History" />
            <span class="jobsTitle">{{ $t('jobHistory.manualValidations') }}</span>
          </div>

          <div class="jobItems" v-if="isOpenManual">
            <div v-for="item in jobItemsManual" :key="item" class="jobItem" :class="{ jobItemActive: selectedItemManual === item }" @click="selectJobItemManual(item)">
              <div v-if="selectedItemManual === item" class="vrCustom"></div>

              <span class="jobItemTitle">{{ $t(`jobStatus.${item.toLowerCase()}`) }}</span>
              <span class="jobCount" :class="getCountClass(item)" :title="getJobCount(item, true)">
                {{ getJobCount(item, 'manual') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isSideBarOpen" class="jobHistoryFilterSidebar">
      <div class="jobHistoryHeaderFilterSideBarOpen">
        <div class="jobHistoryHeaderFilter">
          <div @click="toggleSideBaDropdown">
            <img :class="{ rotated: !isSideBarOpen }" :src="hideSidebarIcon" alt="" />
          </div>

          <div style="display: flex; flex-direction: column; justify-content: space-between">
            <div class="jobItemsSidebar" v-if="isOpen">
              <div style="background-color: #d1e6f1; padding: 2px">
                <img :src="vectorIcon" class="jobHistoryIcon" alt="Job History" />
              </div>

              <div v-for="item in jobItems" :key="item" class="jobItemSidebarOpen" :class="{ jobItemActive: selectedItem === item }" @click="selectJobItem(item)">
                <div v-if="selectedItem === item" class="vrCustom"></div>
                <img v-if="item === 'Pending'" :src="clockIcon" style="width: 40px; height: 40px" alt="" />
                <svg v-else-if="item === 'Completed'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M17.0018 33.0003C15.7361 32.7067 14.5204 32.223 13.3944 31.5651M22.8202 7C25.7122 7.67255 28.2942 9.32497 30.1436 11.6867C31.993 14.0484 33.0001 16.9795 33.0001 20.0002C33.0001 23.0208 31.993 25.9519 30.1436 28.3136C28.2942 30.6753 25.7122 32.3278 22.8202 33.0003M9.11644 27.5437C8.32382 26.3693 7.72124 25.0732 7.33165 23.7045M7 17.7784C7.23274 16.3713 7.68075 15.0383 8.30914 13.8163L8.55497 13.3645M12.5028 9.00845C13.8645 8.05589 15.3911 7.37441 17.0018 7" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5469 19.9999L18.4561 22.9622L24.2745 17.0376" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-else-if="item === 'In Progress'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M17.0018 33.0003C15.7361 32.7067 14.5204 32.223 13.3944 31.5651M22.8202 7C25.7122 7.67255 28.2942 9.32497 30.1436 11.6867C31.993 14.0484 33.0001 16.9795 33.0001 20.0002C33.0001 23.0208 31.993 25.9519 30.1436 28.3136C28.2942 30.6753 25.7122 32.3278 22.8202 33.0003M9.11644 27.5437C8.32382 26.3693 7.72124 25.0732 7.33165 23.7045M7 17.7784C7.23274 16.3713 7.68075 15.0383 8.30914 13.8163L8.55497 13.3645M12.5028 9.00845C13.8645 8.05589 15.3911 7.37441 17.0018 7" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5469 19.9999L18.4561 22.9622L24.2745 17.0376" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-else-if="item === 'Failed'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M18.0018 32C16.7361 31.7064 15.5203 31.2227 14.3944 30.5648M23.8201 6C26.7121 6.67255 29.2941 8.32494 31.1435 10.6866C32.9929 13.0483 34 15.9794 34 19C34 22.0206 32.9929 24.9517 31.1435 27.3134C29.2941 29.6751 26.7121 31.3275 23.8201 32M10.1164 26.5435C9.32381 25.3691 8.72124 24.073 8.33165 22.7043M8 16.7783C8.23273 15.3712 8.68075 14.0382 9.30913 12.8162L9.55496 12.3645M13.5027 8.00843C14.8645 7.05588 16.3911 6.3744 18.0018 6M20.911 13.0754V19M20.911 24.9246V24.9394" stroke="#E50006" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>

            <div class="jobItemsSidebar" style="margin-top: 100px" v-if="isOpen">
              <div style="background-color: #d1e6f1; padding: 2px">
                <img :src="checkDoneIcon" class="jobHistoryIcon" alt="Job History" />
              </div>

              <div v-for="item in jobItemsManual" :key="item" class="jobItemSidebarOpen" :class="{ jobItemActive: selectedItemManual === item }" @click="selectJobItemManual(item)">
                <div v-if="selectedItemManual === item" class="vrCustom"></div>
                <img v-if="item === 'Pending'" :src="clockIcon" style="width: 40px; height: 40px" alt="" />
                <svg v-else-if="item === 'Completed'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M17.0018 33.0003C15.7361 32.7067 14.5204 32.223 13.3944 31.5651M22.8202 7C25.7122 7.67255 28.2942 9.32497 30.1436 11.6867C31.993 14.0484 33.0001 16.9795 33.0001 20.0002C33.0001 23.0208 31.993 25.9519 30.1436 28.3136C28.2942 30.6753 25.7122 32.3278 22.8202 33.0003M9.11644 27.5437C8.32382 26.3693 7.72124 25.0732 7.33165 23.7045M7 17.7784C7.23274 16.3713 7.68075 15.0383 8.30914 13.8163L8.55497 13.3645M12.5028 9.00845C13.8645 8.05589 15.3911 7.37441 17.0018 7" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5469 19.9999L18.4561 22.9622L24.2745 17.0376" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-else-if="item === 'In Progress'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M17.0018 33.0003C15.7361 32.7067 14.5204 32.223 13.3944 31.5651M22.8202 7C25.7122 7.67255 28.2942 9.32497 30.1436 11.6867C31.993 14.0484 33.0001 16.9795 33.0001 20.0002C33.0001 23.0208 31.993 25.9519 30.1436 28.3136C28.2942 30.6753 25.7122 32.3278 22.8202 33.0003M9.11644 27.5437C8.32382 26.3693 7.72124 25.0732 7.33165 23.7045M7 17.7784C7.23274 16.3713 7.68075 15.0383 8.30914 13.8163L8.55497 13.3645M12.5028 9.00845C13.8645 8.05589 15.3911 7.37441 17.0018 7" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5469 19.9999L18.4561 22.9622L24.2745 17.0376" stroke="#00C117" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-else-if="item === 'Failed'" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M18.0018 32C16.7361 31.7064 15.5203 31.2227 14.3944 30.5648M23.8201 6C26.7121 6.67255 29.2941 8.32494 31.1435 10.6866C32.9929 13.0483 34 15.9794 34 19C34 22.0206 32.9929 24.9517 31.1435 27.3134C29.2941 29.6751 26.7121 31.3275 23.8201 32M10.1164 26.5435C9.32381 25.3691 8.72124 24.073 8.33165 22.7043M8 16.7783C8.23273 15.3712 8.68075 14.0382 9.30913 12.8162L9.55496 12.3645M13.5027 8.00843C14.8645 7.05588 16.3911 6.3744 18.0018 6M20.911 13.0754V19M20.911 24.9246V24.9394" stroke="#E50006" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pageContainerJob">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
        <p class="jobHistoryTitle">{{ selectedItem ? $t(`jobStatus.${selectedItem.toLowerCase()}`) : selectedItemManual ? $t(`jobStatus.${selectedItemManual.toLowerCase()}`) : '' }}</p>
        <div style="display: flex; gap: 16px; align-items: center">
          <!-- User Select + Clear Button -->
          <div style="display: flex; align-items: center; gap: 4px; width: 300px; position: relative">
            <select v-if="roleId !== 3" v-model="selectedUserId" @change="handleUserSelect($event.target.value)" class="select-field" style="flex: 1; text-overflow: ellipsis; overflow: hidden; padding-right: 24px; /* Leave space for the × button */ white-space: nowrap; display: block" :title="selectedUserLabel">
              <option :value="''">
                {{ $t('jobHistory.selectUser') }}
              </option>
              <option v-for="user in usersList" :key="user.id" :value="user.id" :title="user.first_name + ' ' + user.last_name + ' (' + user.email_id + ')'">{{ user.first_name }} {{ user.last_name }} ({{ user.email_id }})</option>
            </select>

            <button v-if="selectedUserId" class="resetButtonForSelectUser" style="z-index: 3" @click="handleUserSelect('')" title="Clear selection">×</button>
          </div>

          <!-- Search Bar -->
          <div class="searchBar">
            <button v-if="search" class="resetButton" @click="resetSearch">×</button>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <circle cx="6.5" cy="7.45996" r="5.75" stroke="#8F969B" stroke-width="1.5" />
              <path d="M11 11.96L15 15.96" stroke="#8F969B" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <input style="margin-left: 20px" type="text" class="searchInput" :placeholder="$t('jobHistory.search.placeholder')" v-model="search" @input="handleSearch" />
          </div>
        </div>
      </div>

      <div class="newJobHistoryContainer">
        <div class="tableHeadings" style="width: 100%">
          <!-- <div v-if="writePermission" class="actionsDiv" @click="showActionPopover" style="cursor: pointer">
            <span class="actionsText">{{ $t('jobHistory.actions') }}</span>
          </div> -->
          <!-- <div v-if="writePermission" class="tableVr"></div> -->
          <img :src="refreshIcon" alt="" @click="refreshData" style="cursor: pointer" />
          <img :src="backwardIcon" alt="" @click="goToFirstPage" style="cursor: pointer" />
          <img :src="forwardIcon" alt="" @click="goToNextPage" style="cursor: pointer" />
          <div class="pageDiv">
            <span class="pageDivText">{{ page }}/{{ totalPages }}</span>
          </div>
          <span class="pageOfTitle">{{ $t('jobHistory.pagination.page') }} {{ page }} {{ $t('jobHistory.pagination.of') }} {{ totalPages }}</span>
          <img :src="forwardIcon" style="rotate: 180deg; cursor: pointer" alt="" @click="goToPreviousPage" />
          <svg @click="goToLastPage" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
            <g clip-path="url(#clip0_789_546)">
              <path d="M8.83359 12.2675L4.70497 16.3961C4.68787 16.4132 4.66495 16.4308 4.63263 16.4476C4.62978 16.449 4.62645 16.4502 4.61743 16.4502C4.56598 16.4502 4.53839 16.4378 4.50917 16.4116C4.49849 16.4016 4.48511 16.3868 4.48511 16.3271L4.48511 7.57172C4.48511 7.53641 4.49096 7.52012 4.49314 7.515C4.49488 7.51091 4.49807 7.50446 4.50983 7.49393C4.52876 7.47699 4.54576 7.46598 4.5636 7.45924C4.61068 7.48112 4.6748 7.51322 4.75767 7.55694L8.83359 11.6329C8.89271 11.692 8.93056 11.7478 8.9547 11.7994C8.97262 11.8378 8.9848 11.8855 8.9848 11.9502C8.9848 12.0149 8.97262 12.0626 8.9547 12.101C8.93056 12.1526 8.89271 12.2084 8.83359 12.2675Z" fill="#5C656C" stroke="#5C656C" />
              <line x1="11.4988" y1="17.1206" x2="11.4988" y2="6.12061" stroke="#5C656C" />
            </g>
            <defs>
              <clipPath id="clip0_789_546">
                <rect width="24" height="14" fill="white" transform="matrix(0 -1 1 0 0 24)" />
              </clipPath>
            </defs>
          </svg>
          <div class="pageDiv" @click.stop="togglePageSizeDropdown">
            <span class="pageDivText">{{ pageSize }}</span>
            <img src="/arrowDownNew.png" class="arrowDownNew" alt="" />

            <ul v-if="showPageSizeDropdown" class="pageSizeDropdown">
              <li v-for="size in pageSizeOptions" :key="size" @click.stop="selectPageSize(size)">
                {{ size }}
              </li>
            </ul>
          </div>

          <button class="filter-button" @click="showFilterModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M7 14H21M3.5 7H24.5M10.5 21H17.5" stroke="var(--primary-color)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <div v-if="dateRange && dateRange.length === 2" class="date-filter-chip">
            <span class="date-filter-text"> {{ formatDateForDisplay(dateRange[0]) }} - {{ formatDateForDisplay(dateRange[1]) }} </span>
            <button class="date-filter-clear" @click="clearDateFilter">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="#5C656C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        <div class="tableContainer">
          <div v-if="loading" style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%">
            <div class="spinner-border text-primary spinner-grow-xl" role="status"></div>
          </div>
          <table v-if="!loading" class="customTable">
            <thead class="customTableHeader">
              <tr class="customTableRow">
                <!-- <th class="" style="text-align: center">
                  <input type="checkbox" class="customCheckBox" :checked="masterCheckboxSelected" @change="toggleAllCheckboxes" />
                </th> -->
                <th>{{ $t('jobHistory.table.job_id') }}</th>
                <th v-if="!isBedrock && !isTextract">{{ $t('jobHistory.table.primary_classification') }}</th>
                <th v-if="!isBedrock && !isTextract">{{ $t('jobHistory.table.sub_category') }}</th>
                <th>{{ $t('jobHistory.table.document_types') }}</th>
                <th>{{ $t('jobHistory.table.document_name') }}</th>
                <th>{{ $t('jobHistory.table.uploaded_on') }}</th>
                <th>Created By</th>
                <th>{{ $t('jobHistory.table.status') }}</th>
                <th>{{ $t('jobHistory.table.vasion_status') }}</th>
                <th style="width: 100px">{{ $t('jobHistory.table.actions') }}</th>
              </tr>
            </thead>
            <tbody class="customTableBody">
              <tr v-if="jobData.length === 0" class="no-data-row">
                <td :colspan="getColSpan()" class="no-data-message">
                  <div class="no-data-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <h3>{{ $t('jobHistory.no_data.title') }}</h3>
                    <p>{{ $t('jobHistory.no_data.message') }}</p>
                  </div>
                </td>
              </tr>
              <template v-for="job in jobData" :key="job.id">
                <tr class="main-row">
                  <!-- <td @click="(event) => handleRowClick(event, job)" style="text-align: center; cursor: pointer" @click.stop>
                    <input type="checkbox" class="customCheckBox" :checked="selectedJobs.includes(job?.id)" @change="toggleJobSelection(job?.id)" :disabled="job?.status !== 'completed'" />
                  </td> -->
                  <td @click="(event) => handleRowClick(event, job)" style="text-align: left; cursor: pointer">
                    {{ job?.id }}
                  </td>
                  <td v-if="!isBedrock && !isTextract" @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                    <div class="tooltip-container">
                      <span class="truncate-text">{{ !job?.is_user_selected_classification ? getCategoryNames(job) : getCategoryNamesForUserSelectedClassification(job) || '---' }}</span>
                      <div class="tooltip">
                        {{ !job?.is_user_selected_classification ? getCategoryNames(job) : getCategoryNamesForUserSelectedClassificationTruncated(job) }}
                      </div>
                    </div>
                  </td>
                  <td v-if="!isBedrock && !isTextract" @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                    <div class="tooltip-container">
                      <span class="truncate-text">{{ !job?.is_user_selected_classification ? getDepartmentNames(job) : getDepartmentNamesForUserSelectedClassification(job) || '---' }}</span>
                      <div class="tooltip">
                        {{ !job?.is_user_selected_classification ? getDepartmentNames(job) : getDepartmentNamesForUserSelectedClassificationTruncated(job) }}
                      </div>
                    </div>
                  </td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                    <div class="tooltip-container">
                      <span class="truncate-text">{{ !job?.is_user_selected_classification ? newFormatString(getFullDocumentTypeNames(job)) : newFormatString(getFullDocumentTypeNamesForUserSelectedClassification(job)) || '---' }}</span>
                      <div class="tooltip">
                        {{ !job?.is_user_selected_classification ? newFormatString(getFullDocumentTypeNames(job)) : newFormatString(getFullDocumentTypeNamesForUserSelectedClassificationTruncated(job)) }}
                      </div>
                    </div>
                  </td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" class="truncate-cell">
                    <div class="tooltip-container">
                      <span class="truncate-text">{{ getFileNames(job) || '---' }}</span>
                      <div class="tooltip">
                        {{ getFullFileNames(job) || '---' }}
                      </div>
                    </div>
                  </td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">{{ formatDate(job?.created_at).date }}<br />{{ formatDate(job?.created_at).time }}</td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer" :title="getCreatedBy(job)">
                    {{ getCreatedBy(job) }}
                  </td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">
                    <StatusBadge :status="job?.status" />
                  </td>
                  <td @click="(event) => handleRowClick(event, job)" style="cursor: pointer">
                    <StatusBadge :status="job?.vasion_status" />
                  </td>
                  <td style="text-align: center">
                    <div class="actions-menu" @click.stop>
                      <button v-if="writePermission" class="actions-button" @click="showActionsMenu($event, job)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="6" r="2" fill="var(--primary-color)" />
                          <circle cx="12" cy="12" r="2" fill="var(--primary-color)" />
                          <circle cx="12" cy="18" r="2" fill="var(--primary-color)" />
                        </svg>
                      </button>
                      <div v-if="showActionsDropdown && selectedJob?.id === job?.id" class="actions-dropdown" :class="{ 'actions-dropup': shouldShowDropup }">
                        <div class="action-item" v-if="selectedItem === 'Pending' && job?.status === 'pending'" @click="handleStartJob(job, false)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ $t('job_history.actions.start_job') }}</span>
                        </div>
                        <div class="action-item" v-if="selectedItem !== 'Pending'" @click="handleView(job, false)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21.544 11.045C21.848 11.471 22 11.685 22 12C22 12.316 21.848 12.529 21.544 12.955C20.178 14.871 16.689 19 12 19C7.31 19 3.822 14.87 2.456 12.955C2.152 12.529 2 12.315 2 12C2 11.684 2.152 11.471 2.456 11.045C3.822 9.129 7.311 5 12 5C16.69 5 20.178 9.13 21.544 11.045Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ $t('job_history.actions.view') }}</span>
                        </div>
                        <div v-if="selectedItem !== 'Pending' && selectedItem !== 'Completed' && selectedItemManual !== 'Completed' && selectedItem !== 'Failed' && selectedItemManual !== 'Failed'" class="action-item" @click="handleView(job, true)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M2.5 13.833L6 17.5L7.024 16.427M16.5 6.5L10.437 12.852M7.5 13.833L11 17.5L21.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ $t('job_history.actions.manual_validations') }}</span>
                        </div>
                        <!-- <div class="action-item" @click="showJobInfo(job)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="16" x2="12" y2="12" />
                            <line x1="12" y1="8" x2="12.01" y2="8" />
                          </svg>
                          <span>Job Info</span>
                        </div> -->
                        <div v-if="getApiStatus() !== 'failed' && selectedItem !== 'Pending' && selectedItemManual !== 'Pending' && selectedItem !== 'Completed' && selectedItemManual !== 'Completed'" class="action-item" @click="handleStartWorkflow(job)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21.75 12C21.75 14.5859 20.7228 17.0658 18.8943 18.8943C17.0658 20.7228 14.5859 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C14.5859 2.25 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12Z" stroke="currentColor" stroke-width="1.2" />
                            <path d="M16.5 12L9.75 7.5V16.5L16.5 12Z" stroke="currentColor" />
                          </svg>
                          <span>{{ $t('job_history.actions.start_workflow') }}</span>
                        </div>
                        <div v-if="getApiStatus() !== 'failed' && selectedItem !== 'Pending' && selectedItemManual !== 'Pending' && selectedItem !== 'Completed' && selectedItemManual !== 'Completed'" class="action-item" @click="handleSendToVasion(job)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clip-path="url(#clip0_789_2107)">
                              <path d="M12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V11H6C5.22 11 4.195 11.302 3.38 11.964C2.598 12.6 2 13.572 2 15C2 16.414 2.615 17.388 3.42 18.032C4.256 18.702 5.286 19 6 19C6.973 19 8.239 18.985 9.263 18.479C9.748 18.239 10.163 17.894 10.466 17.382C10.772 16.865 11 16.112 11 15V13.914L9.5 15.414L8.086 14L12 10.086L15.914 14L14.5 15.414L13 13.914V15C13 16.387 12.714 17.51 12.188 18.4C11.7066 19.2108 10.9971 19.8619 10.148 20.272C8.674 21 6.979 21 6.056 21H6C4.832 21 3.362 20.548 2.17 19.593C0.943 18.613 0 17.086 0 15C0 12.928 0.903 11.4 2.12 10.411C2.95554 9.73913 3.94538 9.28614 5 9.093V9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9V9.093C20.0546 9.28614 21.0445 9.73913 21.88 10.411C23.099 11.401 24 12.928 24 15C24 17.076 23.093 18.614 21.795 19.607C20.529 20.575 18.93 21 17.5 21H13.5V19H17.5C18.57 19 19.721 18.675 20.58 18.018C21.407 17.386 22 16.424 22 15C22 13.572 21.402 12.6 20.62 11.964C19.804 11.302 18.78 11 18 11H17V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z" fill="currentColor" stroke="white" stroke-width="0.8" />
                            </g>
                            <defs>
                              <clipPath id="clip0_789_2107">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <span>{{ $t('job_history.actions.send_to_vasion') }}</span>
                        </div>
                        <div v-if="selectedItem === 'Failed' || selectedItemManual === 'Failed'" class="action-item" @click="handleRetry(job)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="17 1 21 5 17 9"></polyline>
                            <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                            <polyline points="7 23 3 19 7 15"></polyline>
                            <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                          </svg>
                          <span>{{ $t('job_history.actions.retry') }}</span>
                        </div>
                        <!-- <div v-if="selectedItem === 'Failed' || selectedItemManual === 'Failed'" class="action-item" @click="handleView(job, true)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M2.5 13.833L6 17.5L7.024 16.427M16.5 6.5L10.437 12.852M7.5 13.833L11 17.5L21.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span>{{ $t('job_history.actions.manual_validations') }}</span>
                        </div> -->
                        <div class="action-item" @click="handleDelete(job)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 6h18"></path>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                            <line x1="10" y1="11" x2="10" y2="17"></line>
                            <line x1="14" y1="11" x2="14" y2="17"></line>
                          </svg>
                          <span>{{ $t('job_history.actions.delete') }}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="showPopover" class="popover-overlay" @click="closePopover">
      <div class="popover-menu" @click.stop :style="{ top: popoverPosition.top, left: popoverPosition.left }">
        <div
          class="popover-item"
          :class="{
            'popover-item-disabled': !shouldShowAction('startWorkflow'),
          }"
          @click="shouldShowAction('startWorkflow') ? handleStartWorkflow() : null"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{ 'svg-disabled': !shouldShowAction('startWorkflow') }">
            <path d="M21.75 12C21.75 14.5859 20.7228 17.0658 18.8943 18.8943C17.0658 20.7228 14.5859 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C14.5859 2.25 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12Z" stroke="currentColor" stroke-width="1.2" />
            <path d="M16.5 12L9.75 7.5V16.5L16.5 12Z" stroke="currentColor" />
          </svg>
          <span>{{ $t('job_history.actions.start_workflow') }}</span>
        </div>
        <div
          class="popover-item"
          :class="{
            'popover-item-disabled': !shouldShowAction('sendToVasion'),
          }"
          @click="shouldShowAction('sendToVasion') ? handleSendToVasion() : null"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{ 'svg-disabled': !shouldShowAction('sendToVasion') }">
            <g clip-path="url(#clip0_789_2107)">
              <path d="M12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V11H6C5.22 11 4.195 11.302 3.38 11.964C2.598 12.6 2 13.572 2 15C2 16.414 2.615 17.388 3.42 18.032C4.256 18.702 5.286 19 6 19C6.973 19 8.239 18.985 9.263 18.479C9.748 18.239 10.163 17.894 10.466 17.382C10.772 16.865 11 16.112 11 15V13.914L9.5 15.414L8.086 14L12 10.086L15.914 14L14.5 15.414L13 13.914V15C13 16.387 12.714 17.51 12.188 18.4C11.7066 19.2108 10.9971 19.8619 10.148 20.272C8.674 21 6.979 21 6.056 21H6C4.832 21 3.362 20.548 2.17 19.593C0.943 18.613 0 17.086 0 15C0 12.928 0.903 11.4 2.12 10.411C2.95554 9.73913 3.94538 9.28614 5 9.093V9C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9V9.093C20.0546 9.28614 21.0445 9.73913 21.88 10.411C23.099 11.401 24 12.928 24 15C24 17.076 23.093 18.614 21.795 19.607C20.529 20.575 18.93 21 17.5 21H13.5V19H17.5C18.57 19 19.721 18.675 20.58 18.018C21.407 17.386 22 16.424 22 15C22 13.572 21.402 12.6 20.62 11.964C19.804 11.302 18.78 11 18 11H17V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4Z" fill="currentColor" stroke="white" stroke-width="0.8" />
            </g>
            <defs>
              <clipPath id="clip0_789_2107">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>{{ $t('job_history.actions.send_to_vasion') }}</span>
        </div>
      </div>
    </div>
    <div v-if="showFilter" class="filter-modal-overlay">
      <div class="filter-modal">
        <div class="filter-modal-header">
          <h2 class="apply-filters-title">{{ $t('jobHistory.filter.title') }}</h2>
          <button class="close-button" @click="closeFilterModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
              <path d="M5.48633 4.66602L16.2882 16.3319" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.48527 16.3319L16.2871 4.66602" stroke="#5A5C62" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="filter-content">
          <div class="filter-section">
            <label class="filter-label">{{ $t('jobHistory.filter.date_range') }}</label>
            <div class="date-input-container">
              <Datepicker v-model="dateRange" range :format="dateFormat" placeholder="MM/DD/YY - MM/DD/YY" :enable-time-picker="false" :clearable="true" class="date-picker" :range-separator="' - '" :multi-calendars="true" :auto-apply="true" text-input :calendar-icon="false" />
            </div>
          </div>
          <div class="filter-actions">
            <button class="cancel-button" @click="closeFilterModalNew">{{ $t('jobHistory.filter.clear') }}</button>
            <button class="apply-button" @click="applyFilter">{{ $t('jobHistory.filter.title') }}</button>
          </div>
        </div>
      </div>
    </div>
    <VasionConfirmationModal :show="showVasionConfirmModal" @close="handleVasionConfirmClose" @confirm="handleVasionConfirm" />
    <DeleteConfirmationModal :show="showDeleteConfirmModal" @close="handleDeleteConfirmClose" @confirm="confirmDelete" />
    <JobDetailsModal :show="showJobDetailsModal" :job="selectedJobForDetails" :job-details="selectedJobForDetails ? getAccordionDetails(selectedJobForDetails) : []" @close="handleJobDetailsClose" @view="handleJobDetailsView" @start-workflow="handleJobDetailsStartWorkflow" @send-to-vasion="handleJobDetailsSendToVasion" @viewJobHistory="handleViewJobHistory" :selectedItem="selectedItem" :selectedItemManual="selectedItemManual" :isBedrock="isBedrock" :job-history-page="page" :job-history-page-size="pageSize" :job-history-date-range="dateRange" :job-history-selected-user-id="selectedUserId" :job-history-search="search" :job-history-is-manually-validated="is_manually_validated" :isTextract="isTextract" from="job-history" />
    <DocumentHistory :show="!!selectedJobForHistory" :job-id="selectedJobForHistory" :selected-result-document="selectedResultDocument" @close="handleDocumentHistoryClose" />
  </div>
  <div v-else>
    <PermissionAlert :message="$t('jobHistory.no_permission')" />
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import StatusBadge from '../../components/StatusBadge.vue'
import PermissionAlert from '../../components/PermissionAlert.vue'
import { get, post, deleteJob, put } from '../../utils/api.js'
import { showToast } from '@/utils/toast'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import VasionConfirmationModal from '@/components/VasionConfirmationModal/VasionConfirmationModal.vue'
import DeleteConfirmationModal from '@/components/DeleteConfirmationModal/DeleteConfirmationModal.vue'
import JobDetailsModal from '@/components/JobDetailsModal/JobDetailsModal.vue'
import DocumentHistory from '@/components/DocumentHistory/DocumentHistory.vue'
import arrowDownIcon from '@/assets/arrowDown.png'
import vectorIcon from '@/assets/Vector.png'
import hideSidebarIcon from '@/assets/hideSidebar.png'
import checkDoneIcon from '@/assets/checkDone.png'
import clockIcon from '@/assets/clock.png'
import refreshIcon from '@/assets/refresh.png'
import backwardIcon from '@/assets/backward.svg'
import forwardIcon from '@/assets/forward.svg'
import { isAiMethodBedrock, isAiMethodTextract } from '@/utils/tenantUtils.js'
import { newFormatString } from '@/documentTraning/src/utils/utils'
export default {
  components: {
    Header,
    Datepicker,
    StatusBadge,
    VasionConfirmationModal,
    DeleteConfirmationModal,
    JobDetailsModal,
    DocumentHistory,
    PermissionAlert,
  },
  data() {
    return {
      roleId: null,
      usersList: [],
      readPermission: false,
      writePermission: false,
      search: '',
      debounceTimeout: null,
      selectedUserId: '',
      is_manually_validated: 0,
      isOpen: true,
      isSideBarOpen: true,
      isOpenManual: true,
      selectedItem: 'Pending',
      selectedItemManual: '',
      jobItems: ['Pending', 'Completed', 'Failed'],
      jobItemsManual: ['Pending', 'Completed', 'Failed'],
      jobData: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
      pageSizeOptions: [10, 20, 50],
      showPageSizeDropdown: false,
      showPopover: false,
      selectedJob: null,
      popoverPosition: {
        top: '20px',
        left: '0px',
      },
      masterCheckboxSelected: false,
      selectedJobs: [],
      showFilter: false,
      dateRange: [],
      dateFormat: 'MM/dd/yyyy',
      expandedRows: [],
      showActionsDropdown: false,
      showVasionConfirmModal: false,
      pendingVasionAction: null,
      showDeleteConfirmModal: false,
      jobToDelete: null,
      jobCounts: {
        jobsPending: 0,
        jobsCompleted: 0,
        jobsFailed: 0,
        jobsTotal: 0,
        ManualPending: 0,
        ManualCompleted: 0,
        ManualFailed: 0,
        ManualTotal: 0,
      },
      showJobDetailsModal: false,
      selectedJobForDetails: null,
      shouldShowDropup: false,
      selectedJobForHistory: null,
      selectedResultDocument: null,
      arrowDownIcon,
      vectorIcon,
      hideSidebarIcon,
      checkDoneIcon,
      clockIcon,
      refreshIcon,
      backwardIcon,
      forwardIcon,
    }
  },
  mounted() {
    document.title = 'Job History'
    const userRolesStr = localStorage.getItem('UserRoles')
    if (userRolesStr) {
      try {
        const userRoles = JSON.parse(userRolesStr)
        if (userRoles.length) {
          // Pick the first roleId (assuming single-role assignment per user)
          this.roleId = userRoles[0].roleId
          if (userRoles[0].role.roleName !== 'Super Admin') {
            this.showJobHistory = true
          }
        }
      } catch (err) {
        console.error('Failed to parse UserRoles:', err)
      }
    }
    this.checkPermissions()
    this.initializeFromUrl()
    this.fetchUsers()
    // Add click event listener for handling clicks outside
    document.addEventListener('click', this.handleClickOutside)
  },
  computed: {
    isBedrock() {
      return isAiMethodBedrock()
    },
    isTextract() {
      return isAiMethodTextract()
    },
  },
  watch: {
    $route(to) {
      // If navigating to job-history, check for stored state and restore it
      if (to.name === 'job-history') {
        // Check if there's stored state (for browser back button support)
        const storedState = sessionStorage.getItem('jobHistoryReturnState')
        if (storedState) {
          this.initializeFromUrl()
        }
      }
    },
  },
  beforeUnmount() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    newFormatString,
    async fetchUsers() {
      try {
        const res = await get('/v1/users?page=1&pageSize=100000') // Update API if needed
        this.usersList = res?.data.data.users?.filter((user) => user.status === 'Active') || []
      } catch (error) {
        console.error('Failed to fetch users:', error)
      }
    },
    handleUserSelect(userId) {
      this.selectedUserId = userId
      this.fetchJobs(this.getApiStatus())
    },
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = true ||  permissions.some((p) => p.object_name === 'JOB_HISTORY_RD' && p.is_active)
      this.writePermission = true || permissions.some((p) => p.object_name === 'JOB_HISTORY_WR' && p.is_active)
    },
    handleClickOutside(event) {
      // Check if click is outside the actions menu and button
      const actionsMenu = document.querySelector('.actions-dropdown')
      const actionsButton = document.querySelector('.actions-button')
      const pageSizeDropdown = document.querySelector('.pageSizeDropdown')
      const pageSizeButton = document.querySelector('.pageDiv')
      const filterModal = document.querySelector('.filter-modal')
      const filterButton = document.querySelector('.filter-button')

      if (this.showActionsDropdown && actionsMenu && !actionsMenu.contains(event.target) && actionsButton && !actionsButton.contains(event.target)) {
        this.showActionsDropdown = false
        this.shouldShowDropup = false
      }

      if (this.showPageSizeDropdown && pageSizeDropdown && !pageSizeDropdown.contains(event.target) && pageSizeButton && !pageSizeButton.contains(event.target)) {
        this.showPageSizeDropdown = false
      }

      if (this.showFilter && filterModal && !filterModal.contains(event.target) && filterButton && !filterButton.contains(event.target)) {
        this.closeFilterModal()
      }
    },
    initializeFromUrl() {
      const query = this.$route.query

      // Check if we're returning from ViewDocument (browser back or direct navigation)
      // First check sessionStorage for preserved state
      const storedState = sessionStorage.getItem('jobHistoryReturnState')
      if (storedState) {
        try {
          const returnQuery = JSON.parse(storedState)
          // Restore state from sessionStorage
          this.page = parseInt(returnQuery.page) || 1
          this.pageSize = parseInt(returnQuery.pageSize) || 10

          if (returnQuery.is_manually_validated === 1 || returnQuery.is_manually_validated === '1') {
            this.is_manually_validated = 1
            this.selectedItemManual = returnQuery.status || 'Pending'
            this.selectedItem = ''
          } else {
            this.is_manually_validated = 0
            this.selectedItem = returnQuery.status || 'Pending'
            this.selectedItemManual = ''
          }

          if (returnQuery.dateRange) {
            try {
              this.dateRange = typeof returnQuery.dateRange === 'string' ? JSON.parse(returnQuery.dateRange) : returnQuery.dateRange
            } catch (e) {
              this.dateRange = []
            }
          }

          if (returnQuery.created_by) {
            this.selectedUserId = returnQuery.created_by
          }

          if (returnQuery.search) {
            this.search = returnQuery.search
          }

          // Clear stored state after using it
          sessionStorage.removeItem('jobHistoryReturnState')

          // Update URL to match restored state
          this.updateUrl()

          // Fetch jobs with restored state
          this.fetchJobs(this.getApiStatus())
          return
        } catch (e) {
          console.error('Failed to parse stored state:', e)
          sessionStorage.removeItem('jobHistoryReturnState')
        }
      }

      // Initialize from URL query parameters (normal flow)
      // Initialize page and pageSize
      this.page = parseInt(query.page) || 1
      this.pageSize = parseInt(query.pageSize) || 10

      // Initialize status and manual validation
      if (query.is_manually_validated === '1') {
        this.is_manually_validated = 1
        this.selectedItemManual = query.status || 'Pending'
        this.selectedItem = ''
      } else {
        this.is_manually_validated = 0
        this.selectedItem = query.status || 'Pending'
        this.selectedItemManual = ''
      }

      // Initialize date range if present
      if (query.dateRange) {
        try {
          this.dateRange = JSON.parse(query.dateRange)
        } catch (e) {
          this.dateRange = []
        }
      }

      // Initialize selected user if present
      if (query.created_by) {
        this.selectedUserId = query.created_by
      }

      // Initialize search if present
      if (query.search) {
        this.search = query.search
      }

      // Fetch jobs with current state
      this.fetchJobs(this.getApiStatus())
    },
    updateUrl() {
      const query = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
        is_manually_validated: this.is_manually_validated,
      }
      if (this.dateRange.length > 0) {
        query.dateRange = JSON.stringify(this.dateRange)
      }
      if (this.selectedUserId) {
        query.created_by = this.selectedUserId
      }
      if (this.search) {
        query.search = this.search
      }

      this.$router.replace({ query })
    },
    getApiStatus() {
      if (this.is_manually_validated) {
        return this.selectedItemManual === 'Pending' ? 'inprogress' : this.selectedItemManual?.toLowerCase()
      } else {
        return this.selectedItem === 'Pending' ? 'inprogress' : this.selectedItem?.toLowerCase()
      }
    },
    async fetchJobs(status) {
      try {
        this.loading = true
        let url = `/v1/mx-jobs?page=${this.page}&pageSize=${this.pageSize}&status=${status}&is_manually_validated=${this.is_manually_validated}`

        if (this.search) {
          url += `&search=${encodeURIComponent(this.search)}`
        }

        if (this.selectedUserId) {
          url += `&created_by=${this.selectedUserId}`
        }

        const from_date = this.formatDateForApi(this.dateRange[0])
        const to_date = this.formatDateForApi(this.dateRange[1])
        if (from_date && to_date) {
          url += `&from_date=${from_date}&to_date=${to_date}`
        }

        const response = await get(url)
        if (response?.status === 200) {
          const data = response.data
          this.jobData = data.data || []
          this.total = data.total
          this.totalPages = Math.ceil(this.total / this.pageSize)
          await this.fetchJobCounts()
        } else {
          this.jobData = []
        }
      } catch (error) {
        console.error('Error fetching jobs:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to fetch jobs',
          type: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    formatDateForApi(date) {
      if (!date) return null
      const d = new Date(date)
      const formattedDate = d.toISOString().split('T')[0] // Returns YYYY-MM-DD format
      return formattedDate
    },
    selectJobItem(item) {
      this.selectedItem = item
      this.selectedItemManual = ''
      this.is_manually_validated = 0
      this.page = 1 // Reset to first page when changing status
      this.updateUrl()
      this.fetchJobs(this.getApiStatus())
    },
    selectJobItemManual(item) {
      this.selectedItemManual = item
      this.selectedItem = ''
      this.is_manually_validated = 1
      this.page = 1 // Reset to first page when changing status
      this.updateUrl()
      this.fetchJobs(this.getApiStatus())
    },
    async refreshData() {
      await this.fetchJobCounts()
      await this.fetchJobs(this.getApiStatus())
    },
    async goToFirstPage() {
      if (this.page !== 1) {
        this.page = 1
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToLastPage() {
      if (this.page !== this.totalPages) {
        this.page = this.totalPages
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToNextPage() {
      if (this.page < this.totalPages) {
        this.page++
        this.updateUrl()
        await this.refreshData()
      }
    },
    async goToPreviousPage() {
      if (this.page > 1) {
        this.page--
        this.updateUrl()
        await this.refreshData()
      }
    },
    async selectPageSize(size) {
      this.pageSize = size
      this.page = 1
      this.showPageSizeDropdown = false
      this.updateUrl()
      await this.refreshData()
    },
    async applyFilter() {
      // const query = {
      //   page: 1,
      //   pageSize: this.pageSize,
      //   status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
      //   is_manually_validated: this.is_manually_validated,
      // }

      // if (this.dateRange && this.dateRange.length === 2) {
      //   const fromDate = this.formatDateForApi(this.dateRange[0])
      //   const toDate = this.formatDateForApi(this.dateRange[1])
      //   if (fromDate && toDate) {
      //     query.from_date = fromDate
      //     query.to_date = toDate
      //   }
      // }

      // this.$router.replace({ query })
      this.page = 1
      await this.fetchJobs(this.getApiStatus())
      this.closeFilterModal()
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    toggleSideBaDropdown() {
      this.isSideBarOpen = !this.isSideBarOpen
    },
    toggleDropdownManual() {
      this.isOpenManual = !this.isOpenManual
    },
    formatDate(dateStr) {
      const dateObj = new Date(dateStr)
      const dateOptions = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }
      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }
      const date = dateObj.toLocaleDateString('en-US', dateOptions)
      const time = dateObj.toLocaleTimeString('en-US', timeOptions)
      return { date, time }
    },
    async handleView(job, isManual) {
      const tenantName = localStorage.getItem('url_name')
      // Preserve current query parameters for returning to the same state
      const returnQuery = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
        is_manually_validated: this.is_manually_validated,
      }
      if (this.dateRange.length > 0) {
        returnQuery.dateRange = JSON.stringify(this.dateRange)
      }
      if (this.selectedUserId) {
        returnQuery.created_by = this.selectedUserId
      }
      if (this.search) {
        returnQuery.search = this.search
      }

      // Store state in sessionStorage for browser back button support
      sessionStorage.setItem('jobHistoryReturnState', JSON.stringify(returnQuery))

      this.$router.push({
        name: 'view-document',
        params: { tenantName },
        query: {
          jobId: job?.id,
          isManual,
          returnQuery: JSON.stringify(returnQuery),
        },
      })
    },
    async handleRowClick(event, job) {
      if (event.target.closest('td:first-child')) {
        return
      }
      this.selectedJobForDetails = job
      this.showJobDetailsModal = true
    },
    togglePageSizeDropdown(event) {
      if (event) {
        event.stopPropagation()
      }
      this.showPageSizeDropdown = !this.showPageSizeDropdown
    },
    getFileNames(job) {
      if (!job?.mx_job_files || job?.mx_job_files?.length === 0) return '---'
      const uniqueFileNames = [...new Set(job?.mx_job_files?.map((file) => file.file_name).filter(Boolean))].join(', ')
      if (uniqueFileNames.length <= 20) return uniqueFileNames
      return uniqueFileNames.substring(0, 20) + '...'
    },
    getFullDocumentTypeNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const uniqueDepartments = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.document_type?.document_type_name).filter(Boolean))].join(', ')
      return uniqueDepartments
    },
    getFullDocumentTypeNamesForUserSelectedClassification(job) {
      if (!job?.document_type || job.document_type.length === 0) return '---'
      const uniqueDepartments = job?.document_type?.document_type_display_name
      return uniqueDepartments
    },
    getFullDocumentTypeNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.document_type || job.document_type.length === 0) return '---'
      const uniqueDepartments = job?.document_type?.document_type_display_name
      if (uniqueDepartments?.length <= 20) return uniqueDepartments
      return uniqueDepartments?.substring(0, 20) + '...'
    },
    getCreatedBy(job) {
      return `${job?.created_by_user?.first_name} ${job?.created_by_user?.last_name}`
    },
    getDepartmentNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const uniqueDepartments = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.department?.department_name).filter(Boolean))].join(', ')
      if (uniqueDepartments.length <= 20) return uniqueDepartments
      return uniqueDepartments.substring(0, 20) + '...'
    },
    getDepartmentNamesForUserSelectedClassification(job) {
      if (!job?.sub_category || job.sub_category.length === 0) return '---'
      const uniqueDepartments = job?.sub_category?.department_display_name
      return uniqueDepartments
    },
    getDepartmentNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.sub_category || job.sub_category.length === 0) return '---'
      const uniqueDepartments = job?.sub_category?.department_display_name
      if (uniqueDepartments?.length <= 20) return uniqueDepartments
      return uniqueDepartments?.substring(0, 20) + '...'
    },
    getCategoryNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const categoryNames = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.category?.category_name).filter(Boolean))].join(', ')
      if (categoryNames.length <= 20) return categoryNames
      return categoryNames.substring(0, 20) + '...'
    },
    getCategoryNamesForUserSelectedClassification(job) {
      if (!job?.primary_classification || job.primary_classification.length === 0) return '---'
      const categoryNames = job?.primary_classification?.category_display_name
      return categoryNames
    },
    getCategoryNamesForUserSelectedClassificationTruncated(job) {
      if (!job?.primary_classification || job.primary_classification.length === 0) return '---'
      const categoryNames = job?.primary_classification?.category_display_name
      if (categoryNames?.length <= 20) return categoryNames

      return categoryNames?.substring(0, 20) + '...'
    },
    getFullFileNames(job) {
      if (!job?.mx_job_result_documents || job?.mx_job_result_documents.length === 0) return '---'
      return [...new Set(job?.mx_job_result_documents.map((file) => file.file_name).filter(Boolean))].join(', ')
    },
    getFullFileNamesAccordian(job, detail) {
      const jobFileId = detail.jobFileId

      if (!job?.mx_job_result_documents || job?.mx_job_result_documents.length === 0) {
        return '---'
      }

      const result_document = job?.mx_job_result_documents?.find((file) => file.mx_job_file_id === jobFileId)
      return result_document?.file_name || '---'
    },
    getFullDepartmentNames(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) return '---'
      const result = [...new Set(job.mx_file_page_textract_details.map((file) => file.tenant_document_type?.department?.department_name).filter(Boolean))].join(', ')
      if (result) {
        return '...'
      } else {
        return result
      }
    },
    showPopoverMenu(event, job) {
      this.selectedJob = job
      this.showPopover = true
      this.popoverPosition = {
        top: `${event.clientY}px`,
        left: `${event.clientX}px`,
      }
    },
    closePopover() {
      this.showPopover = false
      this.selectedJob = null
    },
    handleValidateManually() {
      this.showActionsDropdown = false
      this.shouldShowDropup = false
    },
    async handleStartWorkflow(job) {
      if (this.selectedJobs.length === 0 && !job) {
        showToast({
          title: 'Operation Failed',
          message: 'Please select at least one job',
          type: 'error',
        })
        return
      }

      // Check if any selected job has completed Vasion status
      const hasCompletedVasionStatus = job
        ? job?.vasion_status?.toLowerCase() === 'completed'
        : this.selectedJobs.some((jobId) => {
            const job = this.jobData.find((j) => j?.job?.id === jobId)
            return job?.vasion_status?.toLowerCase() === 'completed'
          })

      if (hasCompletedVasionStatus) {
        this.pendingVasionAction = {
          type: 'workflow',
          jobs: job ? [job?.id] : this.selectedJobs,
        }
        this.showVasionConfirmModal = true
        return
      }

      await this.executeStartWorkflow()
    },
    async executeStartWorkflow() {
      try {
        const jobIds = this.selectedJob ? [this.selectedJob?.id] : this.selectedJobs
        const payload = jobIds.map((jobId) => ({
          job_id: jobId,
          save_to_vasion: false,
        }))
        await post('/v1/vasion/saveall-document', payload)
        showToast({
          title: 'Operation Successful',
          message: 'Workflow started successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        this.shouldShowDropup = false
        await this.refreshData()
      } catch (error) {
        console.error('Error starting workflow:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to start workflow',
          type: 'error',
        })
      }
    },
    async handleSendToVasion(job) {
      if (this.selectedJobs.length === 0 && !job) {
        showToast({
          title: 'Operation Failed',
          message: 'Please select at least one job',
          type: 'error',
        })
        return
      }

      // Check if any selected job has completed Vasion status
      const hasCompletedVasionStatus = job
        ? job?.vasion_status?.toLowerCase() === 'completed'
        : this.selectedJobs.some((jobId) => {
            const job = this.jobData.find((j) => j?.job?.id === jobId)
            return job?.vasion_status?.toLowerCase() === 'completed'
          })
      if (hasCompletedVasionStatus) {
        this.pendingVasionAction = {
          type: 'vasion',
          jobs: job ? [job?.id] : this.selectedJobs,
        }
        this.showVasionConfirmModal = true
        return
      }

      await this.executeSendToVasion()
    },
    async executeSendToVasion() {
      try {
        const jobIds = this.selectedJob ? [this.selectedJob?.id] : this.selectedJobs
        const payload = jobIds.map((jobId) => ({
          job_id: jobId,
          save_to_vasion: true,
        }))
        await post('/v1/vasion/saveall-document', payload)
        showToast({
          title: 'Operation Successful',
          message: 'Documents sent to Vasion successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        this.shouldShowDropup = false
        await this.refreshData()
      } catch (error) {
        console.error('Error sending to Vasion:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to send to Vasion',
          type: 'error',
        })
      }
    },
    handleVasionConfirmClose() {
      this.showVasionConfirmModal = false
      this.pendingVasionAction = null
    },
    async handleVasionConfirm() {
      if (this.pendingVasionAction?.type === 'workflow') {
        await this.executeStartWorkflow()
      } else if (this.pendingVasionAction?.type === 'vasion') {
        await this.executeSendToVasion()
      }
      this.handleVasionConfirmClose()
    },
    showActionPopover(event) {
      this.showPopover = true
      const rect = event.target.getBoundingClientRect()
      this.popoverPosition = {
        top: `${rect.bottom + 5}px`,
        left: `${rect.left}px`,
      }
    },
    toggleAllCheckboxes(event) {
      this.masterCheckboxSelected = event.target.checked
      if (this.masterCheckboxSelected) {
        this.selectedJobs = this.jobData
          .filter((job) => job?.status?.toLowerCase() === 'completed')
          .map((job) => job?.id)
          .filter(Boolean)
      } else {
        this.selectedJobs = []
      }
    },
    toggleJobSelection(jobId) {
      if (!jobId) return
      const index = this.selectedJobs.indexOf(jobId)
      if (index === -1) {
        this.selectedJobs.push(jobId)
      } else {
        this.selectedJobs.splice(index, 1)
      }
      this.masterCheckboxSelected = this.selectedJobs.length === this.jobData.length
    },
    shouldShowAction(actionType) {
      if (this.selectedJobs.length === 0) {
        return false
      }
      const isCompleteOrFailed = ['Completed', 'Failed', 'Pending'].includes(this.selectedItem) || ['Completed', 'Failed', 'Pending'].includes(this.selectedItemManual)
      const singleSelection = this.selectedJobs.length === 1
      const isCompleted = this.selectedItem === 'Completed' || this.selectedItem === 'Pending' || this.selectedItemManual === 'Completed' || this.selectedItemManual === 'Pending'
      switch (actionType) {
        case 'view':
          return isCompleteOrFailed && singleSelection
        case 'validateManually':
          return ['Completed', 'Failed', 'Pending'].includes(this.selectedItemManual) && singleSelection
        case 'startWorkflow':
          return isCompleted
        case 'sendToVasion':
          return isCompleted
        default:
          return false
      }
    },
    showFilterModal() {
      this.showFilter = true
    },
    closeFilterModal() {
      this.showFilter = false
      // this.closeFilterModalNew()
    },
    closeFilterModalNew() {
      this.showFilter = false

      // const query = {
      //   page: this.page,
      //   pageSize: this.pageSize,
      //   status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
      //   is_manually_validated: this.is_manually_validated,
      // }
      // this.$router.replace({ query })
      // this.dateRange = []
      // this.fetchJobs(this.getApiStatus())
    },
    toggleAccordion() {
      // This method is no longer needed
    },
    showActionsMenu(event, job) {
      event.stopPropagation()
      this.selectedJob = job
      this.showActionsDropdown = !this.showActionsDropdown

      // Calculate if dropdown should appear as dropup
      if (this.showActionsDropdown) {
        const button = event.target
        const buttonRect = button.getBoundingClientRect()
        const windowHeight = window.innerHeight
        const dropdownHeight = 300 // Approximate height of dropdown
        const spaceBelow = windowHeight - buttonRect.bottom
        const spaceAbove = buttonRect.top

        // If there's not enough space below but enough space above, show as dropup
        this.shouldShowDropup = spaceBelow < dropdownHeight && spaceAbove > dropdownHeight
      } else {
        // Reset dropup flag when closing dropdown
        this.shouldShowDropup = false
      }
    },
    getAccordionDetails(job) {
      if (!job?.mx_file_page_textract_details || job.mx_file_page_textract_details.length === 0) {
        return []
      }

      // Group details by job file and document type combination
      const groupedDetails = job.mx_file_page_textract_details.reduce((acc, item) => {
        const typeId = item.tenant_document_type_id
        const jobFileId = item.mx_job_file_id
        const mx_job_result_document_id = item.mx_job_result_document_id
        // When mx_job_result_document_id is 0, group by mx_job_file_id (same as ViewDocument)
        const groupKey = mx_job_result_document_id === 0 ? `file_${jobFileId}_` : `${mx_job_result_document_id}_`
        if (!acc[groupKey]) {
          // Create new group for unique document type and job file combination
          acc[groupKey] = {
            category: item.tenant_document_type?.category?.category_name || '---',
            department: item.tenant_document_type?.department?.department_name || '---',
            documentType: item.tenant_document_type?.document_type?.document_type_name || '---',
            jobFileId: jobFileId,
            mx_job_result_document_id: mx_job_result_document_id,
            resultDocument: job?.mx_job_result_documents,
            resultDocumentSelected: job?.mx_job_result_documents?.find((doc) => doc.mx_job_file_id === Number(item.mx_job_file_id) && doc.tenant_document_type_id?.toString() === item.tenant_document_type_id?.toString()),
            typeId: typeId,
          }
        }

        return acc
      }, {})

      // Convert grouped object to array and sort by mx_job_result_document_id in ascending order
      return Object.values(groupedDetails).sort((a, b) => {
        const aId = a.mx_job_result_document_id || 0
        const bId = b.mx_job_result_document_id || 0
        return aId - bId
      })
    },
    getVasionStatusForDetail(detail) {
      if (!detail?.resultDocument || !detail?.jobFileId) return '---'
      const matchingDoc = detail.resultDocument.find((doc) => doc.mx_job_file_id === detail.jobFileId)
      return matchingDoc?.vasion_status || '---'
    },
    async handleRetry(job) {
      try {
        await put(`/v1/mx-jobs/retry/${job?.id}`)
        showToast({
          title: 'Operation Successful',
          message: 'Job retry initiated successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        this.shouldShowDropup = false
        await this.refreshData()
      } catch (error) {
        console.error('Error retrying job:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to retry job',
          type: 'error',
        })
      }
    },
    async handleDelete(job) {
      this.jobToDelete = job
      this.showDeleteConfirmModal = true
    },
    async confirmDelete() {
      try {
        await deleteJob(this.jobToDelete?.id)
        showToast({
          title: 'Operation Successful',
          message: 'Job deleted successfully',
          type: 'success',
        })
        this.showActionsDropdown = false
        this.showDeleteConfirmModal = false
        this.jobToDelete = null
        await this.refreshData()
      } catch (error) {
        console.error('Error deleting job:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to delete job',
          type: 'error',
        })
      }
    },
    handleDeleteConfirmClose() {
      this.showDeleteConfirmModal = false
      this.jobToDelete = null
    },
    async fetchJobCounts() {
      try {
        const response = await get('/v1/mx-jobs/counts')
        if (response?.status === 200) {
          const data = response.data

          // Get first and second keys
          const keys = Object.keys(data)
          const firstKey = keys[0]
          const secondKey = keys[1]

          // Reset all counts to zero first
          this.jobCounts.jobsPending = 0
          this.jobCounts.jobsCompleted = 0
          this.jobCounts.jobsFailed = 0
          this.jobCounts.jobsTotal = 0
          this.jobCounts.ManualPending = 0
          this.jobCounts.ManualCompleted = 0
          this.jobCounts.ManualFailed = 0
          this.jobCounts.ManualTotal = 0

          // Update values based on first key
          if (firstKey === '1') {
            // Update Manual values
            this.jobCounts.ManualPending = data['1']?.pending || 0
            this.jobCounts.ManualCompleted = data['1']?.completed || 0
            this.jobCounts.ManualFailed = data['1']?.failed || 0
            this.jobCounts.ManualTotal = (data['1']?.pending || 0) + (data['1']?.completed || 0) + (data['1']?.failed || 0)
          } else if (firstKey === '0') {
            // Update Jobs values
            this.jobCounts.jobsPending = data['0']?.pending || 0
            this.jobCounts.jobsCompleted = data['0']?.completed || 0
            this.jobCounts.jobsFailed = data['0']?.failed || 0
            this.jobCounts.jobsTotal = (data['0']?.pending || 0) + (data['0']?.completed || 0) + (data['0']?.failed || 0)
          }

          // Update values based on second key (if it exists)
          if (secondKey === '1') {
            // Update Manual values
            this.jobCounts.ManualPending = data['1']?.pending || 0
            this.jobCounts.ManualCompleted = data['1']?.completed || 0
            this.jobCounts.ManualFailed = data['1']?.failed || 0
            this.jobCounts.ManualTotal = (data['1']?.pending || 0) + (data['1']?.completed || 0) + (data['1']?.failed || 0)
          } else if (secondKey === '0') {
            // Update Jobs values
            this.jobCounts.jobsPending = data['0']?.pending || 0
            this.jobCounts.jobsCompleted = data['0']?.completed || 0
            this.jobCounts.jobsFailed = data['0']?.failed || 0
            this.jobCounts.jobsTotal = (data['0']?.pending || 0) + (data['0']?.completed || 0) + (data['0']?.failed || 0)
          }
        }
      } catch (error) {
        console.error('Error fetching job counts:', error)
      }
    },
    getJobCount(item, type) {
      if (type === 'jobs') {
        if (item === 'Pending') {
          return this.jobCounts.jobsPending
        } else if (item === 'Completed') {
          return this.jobCounts.jobsCompleted
        } else if (item === 'Failed') {
          return this.jobCounts.jobsFailed
        }
      } else {
        if (item === 'Pending') {
          return this.jobCounts.ManualPending
        } else if (item === 'Completed') {
          return this.jobCounts.ManualCompleted
        } else if (item === 'Failed') {
          return this.jobCounts.ManualFailed
        }
      }
      // // if (count > 999999) return (count / 1000000).toFixed(1) + 'M'
      // // if (count > 9999) return (count / 1000).toFixed(1) + 'K'
      // return count
    },
    getCountClass(item) {
      switch (item?.toLowerCase()) {
        case 'pending':
          return 'count-pending'
        case 'completed':
          return 'count-completed'
        case 'failed':
          return 'count-failed'
        default:
          return ''
      }
    },
    handleJobDetailsClose() {
      // alert('handleJobDetailsClose')
      this.showJobDetailsModal = false
      this.selectedJobForDetails = null
      this.refreshData()
    },
    handleDocumentHistory(job) {
      this.selectedJobForHistory = job?.id
      this.showActionsDropdown = false
    },
    handleViewJobHistory(data) {
      this.selectedJobForHistory = data.jobId
      this.selectedResultDocument = data.selectedResultDocument
      this.showJobDetailsModal = false // Close the job details modal
    },
    handleDocumentHistoryClose() {
      this.selectedJobForHistory = null
      this.selectedResultDocument = null
    },
    handleJobDetailsView({ detail, isManual, jobId }) {
      // Preserve current query parameters for returning to the same state
      const returnQuery = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.is_manually_validated ? this.selectedItemManual : this.selectedItem,
        is_manually_validated: this.is_manually_validated,
      }
      if (this.dateRange.length > 0) {
        returnQuery.dateRange = JSON.stringify(this.dateRange)
      }
      if (this.selectedUserId) {
        returnQuery.created_by = this.selectedUserId
      }
      if (this.search) {
        returnQuery.search = this.search
      }

      // Store state in sessionStorage for browser back button support
      sessionStorage.setItem('jobHistoryReturnState', JSON.stringify(returnQuery))

      this.$router.push({
        path: '/view-document',
        query: {
          jobId,
          isManual,
          returnQuery: JSON.stringify(returnQuery),
        },
      })
    },
    async handleJobDetailsStartWorkflow(detail) {
      if (detail?.resultDocument?.some((doc) => doc.vasion_status?.toLowerCase() === 'completed')) {
        this.pendingVasionAction = {
          type: 'workflow',
          jobs: [this.selectedJobForDetails?.job?.id],
          detail,
        }
        this.showVasionConfirmModal = true
        return
      }
      await this.executeStartWorkflow(detail)
    },
    async handleJobDetailsSendToVasion(detail) {
      if (detail?.resultDocument?.some((doc) => doc.vasion_status?.toLowerCase() === 'completed')) {
        this.pendingVasionAction = {
          type: 'vasion',
          jobs: [this.selectedJobForDetails?.job?.id],
          detail,
        }
        this.showVasionConfirmModal = true
        return
      }
      await this.executeSendToVasion(detail)
    },
    handleSearch() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.fetchJobs(this.getApiStatus())
      }, 300)
    },
    resetSearch() {
      this.search = ''
      this.fetchJobs(this.getApiStatus())
    },
    async handleStartJob(job, isManual) {
      try {
        const res = await put(`/v1/mx-jobs/${job?.id}`, {})
        if (res?.status === 200) {
          showToast({
            title: 'Operation Successful',
            message: 'Job started successfully',
            type: 'success',
          })
          this.showActionsDropdown = false
          await this.refreshData()
        }
      } catch (error) {
        console.error('Error starting job:', error)
        showToast({
          title: 'Operation Failed',
          message: error?.response?.data?.message || 'Failed to start job',
          type: 'error',
        })
      }
    },
    formatDateForDisplay(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    },
    clearDateFilter() {
      this.dateRange = []
      this.fetchJobs(this.getApiStatus())
    },
    getColSpan() {
      // Calculate the number of columns dynamically
      let colCount = 7 // Base columns: job_id, document_types, document_name, uploaded_on, created_by, status, vasion_status, actions
      if (!this.isBedrock) {
        colCount += 2 // Add primary_classification and sub_category columns
      }
      return colCount
    },
  },
}
</script>

<style scoped>
@import '@/styles/jobHistory.css';

.tableContainer {
  max-height: calc(100vh - 400px);
  min-height: 600px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 17px;
  border-radius: 4px;
}

.customTable {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

/* Column width specifications */
.customTable th:first-child,
.customTable td:first-child {
  width: 100px;
  /* Job ID column */
}

.customTable th:last-child,
.customTable td:last-child {
  width: 100px;
  /* Actions column */
}

.arrowDownIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.arrowDownIcon.rotated {
  transform: rotate(-180deg);
}

.rotated {
  transform: rotate(-180deg);
}

.pageSizeDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
  width: 100%;
}

.pageSizeDropdown li {
  padding: 8px 12px;
  cursor: pointer;
}

.pageSizeDropdown li:hover {
  background-color: #f5f5f5;
}

.pageDiv {
  position: relative;
  cursor: pointer;
}

img[src*='refresh.png'],
img[src*='backward.svg'],
img[src*='forward.svg'] {
  cursor: pointer;
}

.pageDiv {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 12px;
  border-radius: 4px;
  background: #fff;
}

.popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 1000;
}

.popover-menu {
  position: absolute;
  display: flex;
  width: 225px;
  height: 122px;
  padding: 14px 24px 14px 11px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 4px 13.1px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}

.popover-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: capitalize;
}

.popover-item:hover {
  background-color: #f5f5f5;
}

.popover-item svg {
  flex-shrink: 0;
}

.popover-item span {
  white-space: nowrap;
}

.actions-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.action-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.actionsText {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: uppercase;
}

.popover-item-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  color: #999 !important;
}

.popover-item-disabled svg {
  opacity: 0.5;
}

.svg-disabled {
  color: #999 !important;
}

.popover-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: capitalize;
}

.popover-item:not(.popover-item-disabled):hover {
  background-color: #f5f5f5;
}

.filter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.filter-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
}

.filter-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-modal-header h2 {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.24px;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  /* 100% */
  letter-spacing: 0.18px;
}

.filter-content {
  margin-top: 24px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-section label {
  color: #32393e;
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.18px;
  margin-bottom: 12px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

.date-input-container input {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container svg {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-button,
.apply-button {
  padding: 12px 24px;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button {
  background: white;
  border: 1px solid #e8e8e8;
  color: #5c656c;
}

.apply-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.filter-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin-left: auto;
}

.filter-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.filter-section select {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  color: #32393e;
  background: white;
  cursor: pointer;
}

.date-picker {
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

.date-input-container {
  position: relative;
  width: 100%;
}

:deep(.dp__input) {
  height: 40px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
}

:deep(.dp__clear_icon) {
  right: 10px;
}

:deep(.dp__input::placeholder) {
  color: #5c656c;
  opacity: 1;
}

:deep(.dp__menu) {
  font-family: Archivo;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
}

:deep(.dp__range_end),
:deep(.dp__range_start),
:deep(.dp__active_date) {
  background: var(--primary-color);
  color: white;
}

:deep(.dp__range_between) {
  background: rgba(22, 72, 99, 0.1);
  color: var(--primary-color);
}

.main-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.main-row:hover {
  background-color: rgba(22, 72, 99, 0.05);
}

.accordion-row {
  background-color: #c2c9cf !important;
}

.accordion-row td {
  /* padding: 12px 8px; */
  border-bottom: 1px solid #e8e8e8;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
}

.actions-menu {
  position: relative;
  display: inline-block;
  z-index: 10;
}

.actions-button {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.actions-button:hover {
  background-color: rgba(22, 72, 99, 0.1);
}

.actions-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 4px 13.1px rgba(0, 0, 0, 0.1);
  z-index: 200000;
  min-width: 200px;
  padding: 8px 0;
}

.actions-dropup {
  top: auto;
  bottom: 100%;
  margin-bottom: 5px;
}

.action-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 32px;
  cursor: pointer;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  transition: background-color 0.2s;
}

.action-item:hover {
  background-color: #f5f5f5;
}

.action-item svg {
  width: 20px;
  height: 20px;
  color: var(--primary-color);
}

.action-item span {
  white-space: nowrap;
}

.truncate-cell {
  max-width: 150px;
  /* Reduced width */
  /* padding: 8px; */
  position: relative;
}

.tooltip-container {
  position: relative;
  width: 100%;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  word-break: normal;
  overflow-wrap: break-word;
}

.truncate-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.truncate-text:hover {
  color: var(--primary-color);
}

/* Additional styles for accordion rows */
.accordion-row .truncate-cell {
  max-width: 150px;
  /* padding: 8px; */
  position: relative;
}

.accordion-row .tooltip-container {
  position: relative;
  width: 100%;
}

.accordion-row .tooltip {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.2s;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  word-break: normal;
  overflow-wrap: break-word;
}

.accordion-row .tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

/* No data table styling improvements - minimal changes only */
.no-data-row {
  height: 400px;
}

.no-data-row .no-data-message {
  height: 100%;
  vertical-align: middle;
}

.no-data-row .no-data-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px 20px;
}

.jobCount {
  margin-left: auto;
  padding: 2px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  min-width: 40px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
}

.count-pending {
  background-color: #fff4de;
  color: #ffa800;
}

.count-completed {
  background-color: #e8fff3;
  color: #1bc5bd;
}

.count-failed {
  background-color: #ffe2e5;
  color: #f64e60;
}

.jobItem {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  position: relative;
}

.jobItemTitle {
  margin-right: 8px;
}

.searchBar {
  position: relative;
  /* display: flex; */
  /* align-items: center; */
  /* margin-right: 16px; */
}

.searchInput {
  border: none;
  outline: none;
  width: 100%;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  color: #8f969b;
  /* text-align: left; */
}

/* .searchInput {
  padding: 8px 32px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  width: 200px;
} */
.resetButton {
  position: absolute;
  right: 30px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #8f969b;
}

.resetButtonForSelectUser {
  position: absolute;
  right: 20px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #8f969b;
}

.searchBar svg {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}

td {
  overflow: visible !important;
}

.date-filter-chip {
  display: inline-flex;
  align-items: center;
  background-color: #f5f6f7;
  border-radius: 6px;
  padding: 6px 12px;
  margin-left: 12px;
  gap: 8px;
}

.date-filter-text {
  color: #5c656c;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.date-filter-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.date-filter-clear:hover {
  background-color: #e8e9ea;
}

.date-filter-clear svg {
  width: 16px;
  height: 16px;
}

.no-permission {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);
  color: var(--primary-color);
  font-family: Archivo;
}

.select-field {
  width: 100%;
  height: 36px;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: Archivo;
  color: #32393e;
  outline: none;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #8f969b;
}

.no-permission h2 {
  font-size: 24px;
  font-weight: 500;
}
</style>
